import styled from 'styled-components'

export const Outer = styled.div`
  display: flex;
  max-width: 1351px;

  margin: 0 auto;
  justify-content: space-between;
  @media only screen and (max-width: 1180px) {
    justify-content: center;
    flex-wrap: wrap;
  }
`

export const Fold = styled.div`
  display: flex;
  flex: 1;
  min-width: 290px;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2rem 1.8rem;

  > svg {
    height: 150px;
  }

  > h3 {
    margin-top: 2rem;
    font-size: 30px;
    margin-bottom: 1.2rem;
    ${({ headW }) => headW && `max-width: ${headW};`}
  }

  > p {
    font-size: 21px;
    color: #505050;
    max-width: ${({ maxW }) => maxW || `290px`};
  }
  @media only screen and (max-width: 669px) {
    margin-bottom: 4rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
`
